// Simple storage utility for customer statistics
const STATS_KEY = 'customer_stats';
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const statsStorage = {
  get: () => {
    try {
      const stored = localStorage.getItem(STATS_KEY);
      if (!stored) return null;

      const { data, timestamp } = JSON.parse(stored);
      const now = Date.now();

      // Check if cache is expired
      if (now - timestamp > CACHE_DURATION) {
        localStorage.removeItem(STATS_KEY);
        return null;
      }

      return data;
    } catch {
      return null;
    }
  },

  set: (data) => {
    try {
      const toStore = {
        data,
        timestamp: Date.now(),
      };
      localStorage.setItem(STATS_KEY, JSON.stringify(toStore));
    } catch {
      // Ignore storage errors
    }
  },

  clear: () => {
    try {
      localStorage.removeItem(STATS_KEY);
    } catch {
      // Ignore storage errors
    }
  },
};